"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionManager = void 0;
/**
 * Tracks the subscriptions for settings updates.
 */
class SubscriptionManager {
    constructor() {
        this._nextId = 0;
        this._subscriptions = new Map();
    }
    /**
     * Registers a subscription for the given setting, and returns a function that
     * will unregister the subscription when called.
     *
     * @param setting Setting to subscribe to
     * @param onChange Function to call when setting updates
     * @returns Function that cancels this subscription when called
     */
    subscribe(setting, onChange) {
        const id = this._nextId++;
        this._subscriptions.set(id, { setting, onChange });
        return () => this._subscriptions.delete(id);
    }
    /**
     * Notifies all subscribers of the given setting that the value has been
     * updated to the given value.
     *
     * @param setting Setting to notify subscriber for
     * @param value Value of setting
     */
    notifySubscribers(setting, value) {
        this._subscriptions.forEach(subscription => {
            if (subscription.setting === setting)
                subscription.onChange(value);
        });
    }
    /**
     * Cancels all subscriptions.
     */
    clear() {
        this._subscriptions.clear();
        this._nextId = 0;
    }
}
exports.SubscriptionManager = SubscriptionManager;
